<template><svg xmlns="http://www.w3.org/2000/svg" width="10" height="3" viewBox="0 0 10 3">
  <path d="M1.498 1.5H8.5" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>